import { Component, OnInit, AfterViewInit, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgForm } from '@angular/forms';
import { Entity } from '../Classes/EntityClass';
import { CommonSearch } from '../Classes/CommonClass';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { Organization } from '../Classes/OrganizationClass';
import { OrganizationService } from '../Services/OrganizationService';
import { EntityService } from '../Services/EntityService';
import { PayrollRevisionService } from '../Services/PayrollRevisionService';
import { Observable } from 'rxjs';
import { saveAs as importedSaveAs } from "file-saver";
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';
import { SubscriptionModule } from '../Classes/CommonClass';


import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'

@Component({
  selector: 'Organization-Details',
  templateUrl: '../Organization/Organization.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [OrganizationService, EntityService, PayrollRevisionService]
})


export class OrganizationComponent implements OnInit, AfterViewInit {
  SubscriptionModule = SubscriptionModule;
  File: File;
  get_url: string = '';
  errorMessage: any;
  alertClosed: boolean;
  file: File;
  filesToUpload: File[];
  flImport(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  FileModel: any = {};
  _Organization = new Organization();
  _Entity = new Entity();
  isValidFormSubmitted = false;
  _CommonSearch = new CommonSearch();
  _State: boolean = false;
  _Status: boolean = false;
  _RFT: boolean = false;
  innerWidth: number;
  AllState: any[];
  SearchResult: any = [];
  AllUser: any[];
  loading: boolean = false;
  ImportAdd: string = "none";
  ImportSubscriptionAdd: string = "none";
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  @ViewChild("inputBox") _el: ElementRef;
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  //@ViewChild("datepicker") datepicker: DatePickerComponent;
  QueryTenantID: any = [];
  PayrollStatus: any;
  RoleID: string;
  Mode: string;
  FeatureConfig: string;
  AccExec: boolean = false;
  ImportEntitiesdetails: any = [];
  ImportSubscriptiondetails: any = [];
  OrganizationChangeLog: any = [];
  tableRowWidth: number = 99;
  modelTerminationDate: string = "none";
  modelChangeLog: string = "none";
  modelIns: string = 'none';
  _IsValid: boolean = true
  ParentPage: string = "";
  OrgStatus: string = 'Active';
  ConfirmOrg: string = 'none';
  SubsMaxDate: string;
  SubsStatus: string;
  DefaultTimeZone: string = 'EST';
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    inline: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    editableDateField: false,
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };
  public myDatePickerformatOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mmm yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    inline: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    editableDateField: false,
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };

  constructor(private router: Router, private http: Http, public toastr: ToastsManager,
    private Activeroute: ActivatedRoute, private _OrganizationSer: OrganizationService, private _router: Router, vcr: ViewContainerRef, private _EntityService: EntityService,
    private _Payroll: PayrollRevisionService, private confirmDialogService: ConfirmDialogService) {
    //this.form.controls['status'].setValue(this._Organization.Status, { onlySelf: true });
    this.toastr.setRootViewContainerRef(vcr);
  }
  ngOnInit() {
    
    if (this.Activeroute.snapshot.params['TenantID'] != null) {
      var TenantID = this.Activeroute.snapshot.params['TenantID'];
      this.Mode = "Edit";
      this.ParentPage = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
      this.QueryTenantID = JSON.parse(atob(TenantID));
      this.getallstate();
      this.setheight();

      this.GetEditOrgDetails();
      this._Organization.Status = "-1";
      this.FeatureConfig = '1';
      this._Organization.ReportScheduleTime = -1;
      if (this._Organization.ReasonForTermination == "") {
        this._Organization.ReasonForTermination = "-1";
      }
      else {
        this._Organization.ReasonForTermination = "-1";
      }
      this._Payroll.Get_CurrentUserDataLog(this.QueryTenantID).subscribe(res => {

        this.PayrollStatus = res;
        if (this.PayrollStatus != null) {
          this.PayrollStatus.length == 0 ? this.PayrollStatus = 0 : this.PayrollStatus;
          sessionStorage.setItem('PayrollStatus', this.PayrollStatus);
        }
      })
      this._State = true;
      this._Status = true;
      this._RFT = true;
      this._Organization.State = "-1";
      this.RoleID = sessionStorage.getItem('RoleID');
      localStorage.setItem('TenantID', null);

    }
    else {
      this.QueryTenantID = '-1';
      this.Mode = "New";
      this.getallstate();
      this.setheight();
      this._Organization.Status = "-1";
      this._Organization.ReasonForTermination = "-1";
      this._Organization.State = "-1";
      this.FeatureConfig = "0";
      this._Organization.MaxWeeklyHours = "40";
      this._Organization.OwnerEmail = "support@inn-flow.com";
      this._Organization.IFGuruEmail = "support@inn-flow.com";
      this.DefaultTimeZone = "EST";
      this._Organization.DigitalACS = "Disable";
      this.PayrollStatus = sessionStorage.getItem('PayrollStatus');
      this._Organization.APAutomation = false;

    }

    var ParamTenantID = localStorage.getItem('TenantID');
    if (ParamTenantID != "null" && ParamTenantID != null) {
      this.QueryTenantID = ParamTenantID;
      this.getallstate();
      this.setheight();
      this.Mode = "Edit";
      this.GetEditOrgDetails();
      this._Organization.Status = "-1";
      this.FeatureConfig = '1';
      if (this._Organization.ReasonForTermination == "") {
        this._Organization.ReasonForTermination = "-1";
      }
      else {
        this._Organization.ReasonForTermination = "-1";
      }

      this._State = true;
      this._Status = true;
      this._RFT = true;
      this._Organization.State = "-1";


      this.RoleID = sessionStorage.getItem('RoleID');
    }

    this.ChangeHeadeFooterColor();
  }

  ngAfterViewInit() {
    this.GetOrgchangeLog();
  }

  public getallstate() {
    this._OrganizationSer.GetState().subscribe(res => {
      this.AllState = res;
    })
  }

  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementById("mnu_Reports");
      // mnu_Reports.style.background = "#cc4141";


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  public getalluser = (SearchStr: any): Observable<any[]> => {
    if (SearchStr) {
      this._Organization.SearchtextFirst = SearchStr;
      let OrgDetails = { "mQuery": JSON.stringify(SearchStr), "mode": this.Mode, "TenantId": this._Organization.TenantId, "HotelId": this._Organization.Hotelid };
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
      return this.http.get('api/Organization/GetUserDetails', options)
        .map(res => {
          let json = res.json();
          let jsonarray = json;
          return jsonarray;
        })
    }
    else {
      return Observable.of([]);
    }
  }
  public StateChange() {
    this._State = true;
  }
  public StatusChange() {
    this._Status = true;
    this.setheight();


    if (this._Organization.Status == "Inactive") {
      this._Organization.TerminationDate = "";
      this._Organization.TerminationNotes = "";
      this._Organization.ReasonForTermination = "";
    }


  }
  public ReasonForTermination() {
    this._RFT = true;
  }
  FillVendor(value: any) {
    this._Organization.AccountExecutiveNo = value.useruniqueNo;
  }
  CloseOrgConfirm() {
    this.ConfirmOrg = 'none';
  }

  public GetOrgchangeLog() {
    this._OrganizationSer.GetOrgchangeLog(this.QueryTenantID).subscribe(res => {
      this.OrganizationChangeLog = res;
    });
  }

  ShowLog() {
    this.modelChangeLog = "block";
  }

  CloseChangeLog() {
    this.modelChangeLog = "none";
  }

  ShowIns() {
    this.modelIns = "block";
  }

  CloseIns() {
    this.modelIns = "none";
  }


  SaveOrgConfirm(form: NgForm) {
    this.ConfirmOrg = 'none';
    this.loading = true;
    var check = true;
    this._Organization.UserName = sessionStorage.getItem('UserName');
    if (!this._Organization.StartingDate.jsdate) {
      this._Organization.StartingDate = this._Organization.StartingDate;
    }
    else {
      this._Organization.StartingDate = formatDate(this._Organization.StartingDate.jsdate);
    }
    if (this._Organization.Status == "Inactive") {
      if (!this._Organization.TerminationDate.jsdate) {
        this._Organization.TerminationDate = this._Organization.TerminationDate;
      }
      else {
        this._Organization.TerminationDate = formatDate(this._Organization.TerminationDate.jsdate);
      }
    }
    else {
      this._Organization.TerminationDate = "";
      this._Organization.TerminationNotes = "";
      this._Organization.ReasonForTermination = "";
    }
    if (this._Organization.Status == "Inactive") {
      var mTerDate = formatDate(this._Organization.TerminationDate).split("/");
      var _TerYear = mTerDate[0];
      var _TerMonth = mTerDate[1];
      var _TerDay = mTerDate[2];
      var mTerNewDate = _TerMonth + '/01/' + _TerYear;

      var _CurrDate = formatDate(new Date()).split("/");
      var _DateYear = _CurrDate[0];
      var _DateMonth = _CurrDate[1];

      var _finaldate = _DateMonth + '/01/' + _DateYear;


      if (new Date(mTerNewDate) < new Date(this._Organization.StartingDate)) {
        this.toastr.error("Termination Date should be greater than Start Date.");
        check = false;
        this.loading = false;
      }
      else if (new Date(mTerNewDate) < new Date(_finaldate)) {

        this.toastr.error("Termination Date month should be equal to or greater than Current Date month.");
        check = false;
        this.loading = false;
      }
    }

    if (this._Organization.ReportScheduleTime == -1) {

      //this.toastr.error('Please select the Scheduled Report Time.');
      check = false;
      this.loading = false;


    }
    this._OrganizationSer.VerifyTimeSelected(this.QueryTenantID, this._Organization.ReportScheduleTime).subscribe(dataValid => {
      console.log(dataValid);
      
      if (dataValid.text == 'InValid') {

        this.toastr.error(dataValid.alertMsg);
        check = false;
        this.loading = false;


      }

      if (check == true) {

        if (this._Organization.AccountExecutive.username != undefined) {
          this._Organization.AccountExecutive = this._Organization.AccountExecutive.username.trim();
        }
        else {
          this._Organization.AccountExecutive = this._Organization.AccountExecutive.trim();
        }
        this._Organization.BCCEmail = sessionStorage.getItem('BCCEmail');
        
        // for disable ACh
        if (this._Organization.DigitalACS == "Disable") {

          this.confirmDialogService.confirmThis("Disable digital ACH for this enterprise?.", () => {
            //alert("Second yes Clicked");

            this.confirmDialogService.confirmThis("Are you sure?.", () => {

              // alert("Second yes Clicked");

              this.confirmDialogService.confirmThis(" ", () => {
                this._OrganizationSer.SaveOrganizationDetails(this._Organization).subscribe(res => {
                  var data = res;
                  this.loading = false;
                  if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
                    this.toastr.success(data.message, ' TenantId:' + data.tenantId, {
                      allowHtml: true
                    });
                    this._Organization.TenantId = data.tenantId;
                    this._Organization.Hotelid = data.hotelid;

                    this.OrgStatus = this._Organization.Status;
                    this.GetTableData(this._Organization.TenantId);
                    this.QueryTenantID = this._Organization.TenantId;
                    this.GetOrgchangeLog();
                  }
                  else {
                    this.toastr.error(data.message);
                    this.loading = false;
                  }

                });
                // alert("Second yes Clicked");

              },
                () => {
                  //alert("First NO clicked");
                  this.loading = false;
                })

            },
              () => {
                //alert("First NO clicked");
                this.loading = false;
              })

          },
            () => {
              //alert("First NO clicked");
              this.loading = false;
            }).bind(this)


        } else {

          this._OrganizationSer.SaveOrganizationDetails(this._Organization).subscribe(res => {
            var data = res;
            this.loading = false;
            if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
              this.toastr.success(data.message, ' TenantId:' + data.tenantId, {
                allowHtml: true
              });
              this._Organization.TenantId = data.tenantId;
              this._Organization.Hotelid = data.hotelid;

              this.OrgStatus = this._Organization.Status;
              this.GetTableData(this._Organization.TenantId);
              this.QueryTenantID = this._Organization.TenantId;
              this.GetOrgchangeLog();
            }
            else {
              this.toastr.error(data.message);
              this.loading = false;
            }

          });
        }
      }

    }, error => {
      console.log(error);
    });

  }

  public SaveOrganizationDetails(form: NgForm) {
    if (form.valid //&& this.AccExec == false
      && (this._Status != false && this._Organization.Status != "-1") &&
      ((this._State != false && this._Organization.State != "-1") || (this._Organization.NonUSAddress == true)) && (this._IsValid == true)) {
      if ((this._Organization.Status == "Inactive" && this._Organization.ReasonForTermination == "-1")) {
        this._IsValid = false;
      }
      else {
        this._IsValid = true;
      }

      if (this.QueryTenantID == '-1' && this._Organization.Status == "Inactive") {
        this.toastr.error("organization can not terminate while created as new. ");
        this.loading = false;
        return;
      }


      var IsConfirm = true;
      if (this._Organization.Status == "Inactive") {
        //IsConfirm = confirm("Terminating this Organization will terminate all Subscriptions associated with it. Are you sure you want to proceed?");
        this.ConfirmOrg = 'block';
      }
      else {
        this.SaveOrgConfirm(form);
      }
      if (this._Organization.ReportScheduleTime == -1) {
        this.isValidFormSubmitted = true;
      }
    }
    else {
      this.isValidFormSubmitted = true;
      this._State = true;
      this._Status = true;
      this._RFT = true;
    }
  }

  public setheight() {
    this.innerWidth = 100;
    //if (this.QueryTenantID == "-1") {
    //  this.innerWidth = 100;
    //  if (this._Organization.Status == "Inactive") {
    //    this.innerWidth = 100;
    //  }
    //  else {
    //    this.innerWidth = 100;
    //  }
    //}
    //else {
    //  if (this._Organization.Status == "Inactive") {
    //    this.innerWidth = 100;
    //  }
    //  else {
    //    this.innerWidth = 100;
    //  }
    //}
    if (this._Organization.ReasonForTermination == "") {
      this._Organization.ReasonForTermination = "-1";
    }
    //this._RFT = true;
  }

  public GetEditOrgDetails() {
    
    this.loading = true;
    this._OrganizationSer.GetEditOrgDetails(this.QueryTenantID).subscribe(res => {
      var data = res;
      this._OrganizationSer.GetDefaultTimeZone(this.QueryTenantID.toString()).subscribe(data1 => {
        
        this.DefaultTimeZone = data1;
        console.log(data1);
      }, error => { });

      this.EditOrganizationDet(data);
      this.GetTableData(this.QueryTenantID);
      this.setheight();
      this.loading = false;
    });
  }

  public RedirecttoFeatureConfig(TenantID: string) {
    this.router.navigate(['/Feature Configurations', { TenantID: btoa(JSON.stringify(TenantID)), pageName: btoa(JSON.stringify('OrganizationDetails')) }]);
  }

  public RedirecttoPayrollRevision(TenantID: string) {
    this.router.navigate(['/Payroll-Revision', { TenantID: btoa(JSON.stringify(TenantID)) }]);
  }

  EditSubscriptionDetails(EntityId: string, Module: string, EntityCode: string) {
    debugger;
    this.router.navigate(['/SubscriptionDetails', {
      TenantID: btoa(JSON.stringify(this.QueryTenantID)), EntityID: btoa(JSON.stringify(EntityId)),
      Module: btoa(JSON.stringify(Module)), OrganizationCode: btoa(JSON.stringify(this._Organization.OrganizationCode)),
      EntityCode: btoa(JSON.stringify(EntityCode)),
      pageName: btoa(JSON.stringify('CreateEntity'))
    }]);
  }


  public CloseOrganizationDetails(form: NgForm) {
    form.reset()
    if (this.ParentPage == "Subscription") {
      var EntityID = localStorage.getItem('EntityID');
      var OrganizationCode = localStorage.getItem('OrganizationCode');
      this.router.navigate(['/Subscription']);
      //{ TenantID: btoa(JSON.stringify(this.QueryTenantID)), OrgCode: btoa(JSON.stringify(OrganizationCode)), EntityID: btoa(JSON.stringify(EntityID)), pageName: btoa(JSON.stringify('Subscription')) }
    }
    if (this.ParentPage == "SubscriptionDetails") {
      var EntityID = localStorage.getItem('EntityID');
      var Module = localStorage.getItem('Module');
      this.router.navigate(['/SubscriptionDetails', {
        TenantID: btoa(JSON.stringify(this.QueryTenantID)),
        EntityID: btoa(JSON.stringify(EntityID)), Module: btoa(JSON.stringify(Module)),
        OrganizationCode: btoa(JSON.stringify(this._Entity.OrganizationCode)), EntityCode: btoa(JSON.stringify(this._Entity.EntityCode)),
        pageName: btoa(JSON.stringify('Organization'))
      }]);
    }
    else if (this.ParentPage == "EntitySearch") {
      this.router.navigate(['/Entity']);
    }
    else if (this.ParentPage == "CreateEntity") {
      var EntityID = localStorage.getItem('EntityID');
      var OrganizationCode = localStorage.getItem('OrganizationCode');
      this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify(this.QueryTenantID)), OrgCode: btoa(JSON.stringify(OrganizationCode)), EntityID: btoa(JSON.stringify(EntityID)), pageName: btoa(JSON.stringify('Organization')) }]);
    }
    else if (this.ParentPage == "SubscriptionDetails") {

      var EntityID = localStorage.getItem('EntityID');
      var OrganizationCode = localStorage.getItem('OrganizationCode');
      var entityCode = localStorage.getItem('entityCode');
      var module = localStorage.getItem('module');

      this._router.navigate(['/SubscriptionDetails', {
        TenantID: btoa(JSON.stringify(this.QueryTenantID)),
        OrganizationCode: btoa(JSON.stringify(OrganizationCode)),
        EntityID: btoa(JSON.stringify(EntityID)),
        Module: btoa(JSON.stringify(module)),
        EntityCode: btoa(JSON.stringify(entityCode)),
        pageName: btoa(JSON.stringify('SubscriptionDetails'))
      }]);
    }
    else {
      localStorage.setItem('TenantID', 'null');
      this.router.navigate(['/Organization']);
    }

  }

  public EditOrganizationDet(data: any) {
    
    if (data != null) {
      if (data.nonUSAddress == 'No') {
        data.nonUSAddress = false;
      }
      else {
        data.nonUSAddress = true;
      }
      this.SubsMaxDate = data.maxdata;
      this.SubsStatus = data.subscriptionStatus;
      this._Organization.Hotelid = data.hotelid;
      this._Organization.TenantId = data.tenantId;
      this._Organization.City = data.city;
      this._Organization.AccountExecutive = data.accountExecutive;
      this._Organization.AccountExecutiveNo = data.accountExecutiveNo;
      this._Organization.Country = data.country;
      this._Organization.State = data.state;
      this._Organization.Province = data.province;
      this._Organization.AStreet = data.astreet;
      this._Organization.IFGuru = data.ifguru;
      this._Organization.IFGuruEmail = data.ifguruEmail;
      this._Organization.IFGuruPhone = data.ifguruPhone;
      this._Organization.NonUSAddress = data.nonUSAddress;
      this._Organization.LegalName = data.legalName;
      this._Organization.OrganizationName = data.organizationName;
      this._Organization.OrganizationCode = data.organizationCode;
      this._Organization.OwnerEmail = data.ownerEmail;
      this._Organization.OwnerName = data.ownerName;
      this._Organization.OwnerPhone = data.ownerPhone;
      this._Organization.ReportScheduleTime = data.reportScheduleTime;
      this._Organization.DigitalACS = data.digitalACS;
      //var Startdate = new Date(data.startingDate);
      //Startdate.setDate(Startdate.getDate() + 1);
      this._Organization.StartingDate = { jsdate: new Date(data.startingDate) };
      this._Organization.Status = data.status;
      this.OrgStatus = data.status;
      this._Organization.TaxID = data.taxId;
      if (data.reasonForTermination != null) {
        this._Organization.ReasonForTermination = data.reasonForTermination;
      }
      // var Terminationdate = new Date(data.terminationDate);
      //Terminationdate.setDate(Terminationdate.getDate() + 1);
      if (data.status == "Inactive") {
        if (data.terminationDate == "null") {
          this._Organization.TerminationDate = "";
        }
        else {
          this._Organization.TerminationDate = { jsdate: new Date(data.terminationDate) };
        }
      }
      this._Organization.TerminationNotes = data.terminationNotes;
      this._Organization.ZipCode = data.zipCode;
      this._Organization.MaxWeeklyHours = data.maxWeeklyHours;
      if (data.apAutomation == 0 || data.apAutomation == undefined) {
        this._Organization.APAutomation = false;
      }
      else {
        this._Organization.APAutomation = true;
      }
    }
  }

  public Keypress(event: any) {
    const pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //public keypressForState(event: any) {
  //  const pattern = /^[a-zA-Z ]*$/;
  //  let inputChar = String.fromCharCode(event.charCode);
  //  if (event.keyCode != 8 && !pattern.test(inputChar)) {
  //    event.preventDefault();
  //  }
  //}


  public keyPress(event: any) {
    const pattern = /[0-9\+\-\\]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public keyUp(event: any) {
    const pattern = /[0-9\+\-\\]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public strimdata(val: string) { return val.trim() }

  public GetTableData(TenantID) {
    var mQuery: string = "";
    mQuery += "where " + 'dt.tenantID' + ' = ' + "'" + TenantID + "'";
    this._CommonSearch.SearchQuery = mQuery;
    this._EntityService.GetEntitySearchResult(this._CommonSearch).subscribe(res => {
      var data = res;
      if (data.length > 15) {
        this.tableRowWidth = 100;

      }
      else {
        this.tableRowWidth = 99;
      }
      this.SearchResult = data;
      console.log(this.SearchResult);
      this.loading = false;
    });
  }
  AddNewEntity() {
    this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify(this.QueryTenantID)), OrgCode: btoa(JSON.stringify(this._Organization.OrganizationCode)), pageName: btoa(JSON.stringify('Organization')) }]);
  }

  EditNewEntity(EntityID: string) {
    this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify(this.QueryTenantID)), OrgCode: btoa(JSON.stringify(this._Organization.OrganizationCode)), EntityID: btoa(JSON.stringify(EntityID)), pageName: btoa(JSON.stringify('Organization')) }]);
  }
  @ViewChild('myModal') myModal;

  ImportpopupOpen() {
    this.ImportAdd = "block";
  }
  closeModel(form: NgForm) {
    this.ImportAdd = "none";
    this.ImportEntitiesdetails.length = 0;
    form.reset();
  }

  DownloadFile() {

    this._OrganizationSer.GetEntitiesExportTemplate().subscribe(res => {

      importedSaveAs(res, "EntityImportTemplate.xlsx");

    })
  }

  fileChange(event: any) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.File = fileList[0];
    }
  }


  ImportFile(form: NgForm) {

    if (form.controls.AttachFile.value != null) {
      this.loading = true;
      let file: File = this.File;
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      let headers = new Headers()
      //headers.append('Content-Type', 'json');  
      //headers.append('Accept', 'application/json');  
      let param = {

        "Tenantid": JSON.stringify(this.QueryTenantID),
        "UserName": JSON.stringify(sessionStorage.getItem('UserName'))
      };
      let options = new RequestOptions({ headers: headers, params: param });

      let apiUrl1 = "api/Organization/UploadFile";
      this.http.post(apiUrl1, formData, options)
        .map(res => res.json())
        .catch(error => Observable.throw(error))
        .subscribe(res => {

          let data = res;
          this.ImportEntitiesdetails = data;
          if (this.ImportEntitiesdetails[0].result) {
            if (this.ImportEntitiesdetails[0].result == "Record Saved Successfully") {
              this.loading = false;
              this.toastr.success(this.ImportEntitiesdetails[0].result);
              this.GetTableData(this.QueryTenantID);
              this.closeModel(form);
            }
            else {
              this.loading = false;
              this.toastr.error(this.ImportEntitiesdetails[0].result);
              this.GetTableData(this.QueryTenantID);
              this.closeModel(form);
            }
            this.loading = false;
            form.reset();

          }
          else {

            form.reset();
          }
          this.loading = false;

        })
    }
    else {
      this.loading = false;
      this.toastr.error('Please select file.');
    }
  }

  ImportSubscriptionpopupOpen() {
    this.ImportSubscriptionAdd = "block";
  }
  closeSubscriptionModel(form: NgForm) {
    this.ImportSubscriptionAdd = "none";
    this.ImportSubscriptiondetails.length = 0;
    form.reset();
  }

  DownloadSubscriptionFile() {
    


    this._OrganizationSer.GetSubscriptionExportTemplate(this.QueryTenantID).subscribe(res => {
      /// this.loading = true; 
      importedSaveAs(res, "SubscriptionImportTemplate.xlsx");
      // this.loading = false; 
    })

  }

  fileChangeSubscription(event: any) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.File = fileList[0];
    }
  }


  ImportSubscriptionFile(form: NgForm) {
    if (form.controls.AttachFileSubscription.value != null) {
      this.loading = true;
      let file: File = this.File;
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      let headers = new Headers()
      //headers.append('Content-Type', 'json');  
      //headers.append('Accept', 'application/json');  
      let param = {

        "Tenantid": JSON.stringify(this.QueryTenantID),
        "UserName": JSON.stringify(sessionStorage.getItem('UserName').toString())
      };
      let options = new RequestOptions({ headers: headers, params: param });

      let apiUrl1 = "api/Organization/UploadSubscriptionFile";
      this.http.post(apiUrl1, formData, options)
        .map(res => res.json())
        .catch(error => Observable.throw(error))
        .subscribe(res => {

          let data = res;
          this.ImportSubscriptiondetails = data;
          if (this.ImportSubscriptiondetails[0].result) {
            if (this.ImportSubscriptiondetails[0].result == "Record Saved Successfully") {
              this.toastr.success(this.ImportSubscriptiondetails[0].result);
              this.GetTableData(this.QueryTenantID);
              this.closeSubscriptionModel(form);
            }
            else {
              this.toastr.error(this.ImportSubscriptiondetails[0].result);
              this.GetTableData(this.QueryTenantID);
              // this.closeSubscriptionModel(form);
              //this.ope
              this.ImportSubscriptiondetails.length = 0;
            }
            form.reset();
            this.loading = false;
          }
          else {

            form.reset();
            this.loading = false;
          }
        })
    }
    else {
      this.loading = false;
      this.toastr.error('Please select file.');
    }
  }


  OpenTerminationModal() {
    this.modelTerminationDate = "block";
  }

  CloseTerminationDate() {
    this.modelTerminationDate = "none";
  }


  CheckExtender(Name: any) {
    if (Name.useruniqueNo == "" || Name.useruniqueNo == undefined) {
      //if (Name == null) {
      this.AccExec = true;
      //}
      //      this.isValidFormSubmitted = true;

    }
    else {
      this.AccExec = false;
    }
  }
}



function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}







// WEBPACK FOOTER //
// ./src/app/Organization/Organization.component.ts